import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { ImageCroppedEvent } from 'ngx-image-cropper';

export interface DialogData {
  event: any;
  maintainAspectRatio: any;
  aspectRatio: any;
  resizeToWidth: any;
  resizeToHeight: any;
}
@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.css']
})
export class ImageCropperComponent implements OnInit {

  public selectedFile: any = '';
  public fileName: string = '';
  public fileExtension: string = '';
  public imageChangedEvent: any = '';
  public croppedImage: any = '';
  public imageload: boolean = false;
  public cropperOn: boolean = false;
  public imageloadMessage: string = 'Image Loading...';
  public result: object = {status: false};

  constructor(
    public dialogRef: MatDialogRef<ImageCropperComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ){}

  ngOnInit() {
    this.imageChangedEvent = this.data.event;
    this.selectedFile = this.data.event.target.files[0];
    this.fileName = this.selectedFile.name;
    this.fileExtension = this.fileName.split('.').pop();

    if (this.selectedFile.type  === 'image/svg+xml') {
      this.fileExtension = 'png';
      const fileNameWithoutExtension = this.getFileNameWithoutExtension(this.fileName);
      this.fileName = `${fileNameWithoutExtension}.${this.fileExtension}`;
      this.convertSvgToPng(this.selectedFile);
      
    } else {
      this.cropperOn = true;
    }
  }

  onNoClick(): void {
    this.dialogRef.close(this.result);
  }

  cropImageAndUpload = function () {
    this.result.status = true;
    this.result.fileName = this.fileName;
    this.dialogRef.close(this.result);
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.result = {
      file: event.file,
      base64: event.base64,
      height: event.height,
      width: event.width,
      cropperPosition: event.cropperPosition,
      imagePosition: event.imagePosition,
      offsetImagePosition: event.offsetImagePosition,
      transform: event.transform
    };
  }
  imageLoaded() {
    this.imageload = true;
  }
  loadImageFailed() {
    this.imageload = false;
    this.imageloadMessage = "Only .jpeg, .jpg, .png, .gif and .svg file formats are allowed.";
  }

  convertSvgToPng(file: File) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const svgContent: string = e.target.result;
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        // Convert canvas to PNG
        canvas.toBlob((blob) => {
          const pngFile = new File([blob], file.name.replace('.svg', '.png'), { type: 'image/png' });
          // Now you can use ngx-image-cropper with the PNG file
          this.imageChangedEvent = { target: { files: [pngFile] } };
        }, 'image/png');
      };
      img.src = 'data:image/svg+xml;base64,' + btoa(svgContent);
    };
    reader.readAsText(file);
    this.cropperOn = true;
  }

  getFileNameWithoutExtension(fileName: string): string {
    const index = fileName.lastIndexOf('.');
    if (index === -1) {
      return fileName; // If no dot is present in the filename
    }
    return fileName.substring(0, index);
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/shared/image-cropper/image-cropper.component.ts